import { render, staticRenderFns } from "./ProductCarousel2.vue?vue&type=template&id=e152c050&scoped=true&"
import script from "./ProductCarousel2.vue?vue&type=script&lang=ts&"
export * from "./ProductCarousel2.vue?vue&type=script&lang=ts&"
import style0 from "./ProductCarousel2.vue?vue&type=style&index=0&id=e152c050&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e152c050",
  null
  
)

export default component.exports